import styled from "styled-components";

export const Container = styled.div`
  max-width: 1142px;
  width: 90%;
  margin: 0 auto;

  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;

export const BackResult = styled.div`
  button {
    color: rgb(44, 118, 170) !important;

    div:last-child {
      border-bottom: 1px solid rgb(44, 118, 170) !important;
    }
  }
`;

export const BoxTitleService = styled.div`
  border-radius: 10px 0 0 10px;
  background: #ffffff;
  padding: 10px;
  width: 100%;
  border-left: 1px solid #eaeaea;
  height: 54px;
`;

export const BoxTitleServiceRight = styled.div`
  border-radius: 0 10px 10px 0;
  background: #ffffff;
  border-right: 1px solid #eaeaea;
  height: 54px;
  display: flex;
  overflow-x: auto;
`;

export const BoxSubService = styled.div`
  margin-top: 10px;
  width: 100%;
  border-radius: 10px 0 0 10px;
  background: #ffffff;
`;

export const ItemContentInSubService = styled.div`
  font-size: 13px;
  line-height: 24px;
  font-weight: 400;
  color: #000;
  padding: 10px 30px;
  height: 44px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  text-wrap: nowrap;
  border-style: solid;
  border-width: 0px 1px 1px 0px;
  border-color: #eaeaea;
`;
